import { createRoute } from '@tanstack/react-router'
import { AddDocumentPage } from '@/features/documents/pages/AddDocumentPage'
import { Route as documentsRoute } from '../documents'

export const Route = createRoute({
  getParentRoute: () => documentsRoute,
  path: '/add',
  component: AddDocumentPage,
})
